import { useQuery } from 'react-query';

import listedKitService from 'resources/listedkit/listedkit.service';

import { getMilestonesWithTasks } from 'resources/listedkit/workflows';

const getListedKitById = async (id) => {
  const listedKit = await listedKitService.findById(id);

  const milestonesWithTasks = await getMilestonesWithTasks(listedKit);

  delete milestonesWithTasks.milestone_ids;

  // in case of milestone was deleted but milestone_ids not updated
  listedKit.milestones = milestonesWithTasks.filter((m) => !!m);

  return listedKit;
};

export default function useListedKit(id) {
  return useQuery(
    ['listedKits.getById', id],
    () => getListedKitById(id),
  );
}
